import {AxiosError} from 'axios';
import {POST_CREATE_ANNOUNCEMENT_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {RecipientSelection} from './useGetAnnouncementDetails';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CreateAnnouncementRequest {
  title?: string;
  description?: string;
  priority?: boolean;
  startDate?: string;
  endDate?: string;
  announcementType: string;
  fileUuids: string[];
  recipientSelection?: RecipientSelection;
}

interface CreateAnnouncementResponse {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: CreateAnnouncementResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateAnnouncement = ({onSuccess, onError}: Input = {}) => {
  const postCreateAnnouncement = async (requestData: CreateAnnouncementRequest) => {
    const res = await axiosClient.post<CreateAnnouncementResponse>(
        POST_CREATE_ANNOUNCEMENT_URL,
        requestData
    );
    return res.data;
  };

  return useCustomMutation(postCreateAnnouncement, {
    onSuccess,
    onError,
  });
};
